export enum ColumnAggregationType {
    SUM = 'SUM',
    MEAN = 'MEAN',
    COUNT = 'COUNT',
}

export enum TemplateLoadingType {
    EVERYTHING = 'EVERYTHING',
    FIXED_PERIOD = 'FIXED_PERIOD',
    RANGE = 'RANGE'
}

export enum IConfigDataConfigSortingStrategy {
    KEY_AND_META_KEY = 'KEY_AND_META_KEY',
    CREATION_DATE = 'CREATION_DATE'
}

export enum CellType {
    NONE = 'NONE',
    LONG = 'LONG',
    DOUBLE = 'DOUBLE',
    STRING = 'STRING',
    DATETIME = 'DATETIME',
    TIME = 'TIME',
    TIMESPAN = 'TIMESPAN',
    USER_SIGNATURE = 'USER_SIGNATURE',
    FOREIGN_KEY = 'FOREIGN_KEY',
    INSTANT = 'INSTANT',
    MULTI_VALUE = 'MULTI_VALUE',
    MULTI_FOREIGN_KEY = 'MULTI_FOREIGN_KEY'
}

export enum CellSubType {
    LONG = 'LONG',
    DOUBLE = 'DOUBLE',
    STRING = 'STRING',
    TIME = 'TIME',
    TIMESPAN = 'TIMESPAN'
}

export enum RequestMethod{
    GET = 'GET',
    POST = 'POST',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
    PUT = 'PUT'
}

export enum Operator {
    STARTS_WITH = 'START_WITH',
    CONTAINS = 'CONTAINS',
    EQ = 'EQ',
    NE = 'NE',
    GT = 'GT',
    GTE = 'GTE',
    LT='LT',
    LTE='LTE'
}

export enum ToastSeverity {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
    WARNING = 'warining'
}